"use client";

import Link from "next/link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import {
  Briefcase,
  Users,
  Globe2,
  Rocket,
  MapPin,
  Clock,
} from "lucide-react";

const jobs = [
  {
    title: "Frontend Developer (React / Next.js)",
    location: "Pune / Remote",
    type: "Full-time",
  },
  {
    title: "Backend Developer (Node / Spring Boot)",
    location: "Pune",
    type: "Full-time",
  },
  {
    title: "Business Development Executive",
    location: "Mumbai / Pune",
    type: "Full-time",
  },
];

export default function CareersPage() {
  return (
    <div className="bg-white dark:bg-slate-950">

      {/* HERO */}
      <section className="py-20 border-b bg-gradient-to-b from-slate-50 to-white text-center">
        <div className="container mx-auto px-4">
          <Badge className="bg-orange-100 text-orange-700">
            Careers
          </Badge>

          <h1 className="mt-4 text-4xl sm:text-5xl font-bold max-w-3xl mx-auto leading-tight">
            Build the future of{" "}
            <span className="text-orange-600">
              global trade
            </span>
          </h1>

          <p className="mt-4 text-muted-foreground max-w-2xl mx-auto">
            Join DoExim and work on real-world problems in sourcing,
            supply chain, and global commerce.
          </p>
        </div>
      </section>

      {/* WHY JOIN */}
      <section className="py-16 border-b">
        <div className="container mx-auto px-4 grid md:grid-cols-4 gap-6 text-center">

          <div>
            <Globe2 className="mx-auto text-orange-600 mb-2" />
            <h3 className="font-semibold">Global Impact</h3>
            <p className="text-sm text-muted-foreground">
              Work with international buyers & suppliers.
            </p>
          </div>

          <div>
            <Rocket className="mx-auto text-orange-600 mb-2" />
            <h3 className="font-semibold">Fast Growth</h3>
            <p className="text-sm text-muted-foreground">
              Learn in a high-speed startup environment.
            </p>
          </div>

          <div>
            <Users className="mx-auto text-orange-600 mb-2" />
            <h3 className="font-semibold">Strong Team</h3>
            <p className="text-sm text-muted-foreground">
              Work with experienced builders.
            </p>
          </div>

          <div>
            <Briefcase className="mx-auto text-orange-600 mb-2" />
            <h3 className="font-semibold">Ownership</h3>
            <p className="text-sm text-muted-foreground">
              Take full ownership of features.
            </p>
          </div>

        </div>
      </section>

      {/* JOB LIST */}
      <section className="py-16">
        <div className="container mx-auto px-4 max-w-4xl">

          <h2 className="text-2xl font-semibold mb-6">
            Open Positions
          </h2>

          <div className="space-y-4">
            {jobs.map((job) => (
              <div
                key={job.title}
                className="border rounded-xl p-5 hover:shadow-md transition flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4"
              >
                <div>
                  <h3 className="font-semibold text-lg">
                    {job.title}
                  </h3>

                  <div className="flex items-center gap-4 text-sm text-muted-foreground mt-1">
                    <span className="flex items-center gap-1">
                      <MapPin className="h-4 w-4" />
                      {job.location}
                    </span>

                    <span className="flex items-center gap-1">
                      <Clock className="h-4 w-4" />
                      {job.type}
                    </span>
                  </div>
                </div>

                <Button asChild>
                  <Link href="/welcome/contact">
                    Apply Now
                  </Link>
                </Button>
              </div>
            ))}
          </div>

        </div>
      </section>

      {/* CTA */}
      <section className="py-16 border-t text-center">
        <h2 className="text-xl font-semibold">
          Didn’t find a role?
        </h2>

        <p className="text-muted-foreground mt-2">
          Send us your profile and we’ll reach out.
        </p>

        <div className="mt-6">
          <Button asChild>
            <Link href="/welcome/contact">
              Contact Us
            </Link>
          </Button>
        </div>
      </section>

    </div>
  );
}